import { render, staticRenderFns } from "./NoticeOfHearingAppLeaveGrantedPg.vue?vue&type=template&id=3c0364aa&scoped=true"
import script from "./NoticeOfHearingAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./NoticeOfHearingAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0364aa",
  null
  
)

export default component.exports